import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {HttpErrorResponse, HttpHeaders, HttpResponse} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {IPhone, Phone} from '../../shared/model/phone.model';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {JhiEventManager, JhiParseLinks, JhiAlertService} from 'ng-jhipster';
import * as moment from 'jalali-moment';
import {NgxSpinnerService} from 'ngx-spinner';
import {AccountService} from '../../singelton/account.service';
import {PhoneService} from "../../entities/phone/phone.service";
import {PhoneUpdateComponent} from "../../entities/phone/phone-update.component";
import {PhoneDeleteDialogComponent} from "../../entities/phone/phone-delete-dialog.component";

@Component({
  selector: 'app-advanced-search-phone',
  templateUrl: './advanced-search-phone.component.html'
})
export class AdvancedSearchPhoneComponent implements OnInit {
  @Input() term;
  currentAccount: any;
  phones: IPhone[];
  phone: IPhone = new Phone();
  error: any;
  success: any;
  eventSubscriber: Subscription;
  routeData: any;
  links: any;
  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  closeResult: string;

  pageCount: any;
  start: any;
  end: any;

  constructor(protected phoneService: PhoneService,
              protected parseLinks: JhiParseLinks,
              protected jhiAlertService: JhiAlertService,
              public accountService: AccountService,
              protected activatedRoute: ActivatedRoute,
              protected router: Router,
              private spinner: NgxSpinnerService,
              protected eventManager: JhiEventManager) {

    this.itemsPerPage = 3;
    this.page = 1;
    this.predicate = 'audience';
    this.reverse = 'asc';

  }


  loadPage2(param) {
    if (this.predicate === param) {
      if (this.reverse === 'asc') {
        this.reverse = 'desc';
      } else {
        this.reverse = 'asc';
      }
    } else {
      this.reverse = 'asc';
    }
    this.predicate = param;
    this.transition(this.page);
  }


  transition(page) {
    this.search(page, false);
  }

  ngOnInit() {
    this.search(this.page, true);
  }


  trackId(index: number, item: IPhone) {
    return item.id;
  }


  protected paginatePhones(data: IPhone[], headers: HttpHeaders, firstLoad) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;


    this.start = ((this.page - 1) * this.itemsPerPage) + 1;
    const temp = this.totalItems % this.itemsPerPage;
    this.pageCount = this.totalItems / this.itemsPerPage;
    this.end = Number((this.page - 1) * this.itemsPerPage) + Number(this.itemsPerPage);

    if (temp > 0) {
      if (this.page <= (Math.round(this.pageCount) - 1)) {
        this.end = (Number(this.page - 1) * Number(this.itemsPerPage)) + Number(this.itemsPerPage);
      } else {
        if (this.itemsPerPage < this.totalItems) {
          this.end = (Number(this.page - 1) * Number(this.itemsPerPage)) + Number(this.itemsPerPage);
        } else {
          this.end = Number((this.page - 1) * this.itemsPerPage) + Number(temp);

        }
      }
    } else {
      this.end = Number((this.page - 1) * this.itemsPerPage) + Number(this.itemsPerPage);
    }
    if (((this.end)) > ((this.totalItems))) {
      this.end = this.totalItems;
    }
    this.phones = data;
    this.spinner.hide();
  }


  search(page, firstLoad) {
    this.spinner.show();
    if (page) {
      this.page = page;
    } else {
      this.page = 1;
    }

    this.accountService.identity().then(account => {
      const term = this.term;
      this.phoneService
        .searchAdvanced({
          page: this.page - 1,
          size: this.itemsPerPage,
          sort: this.sort(),
          term,
        })
        .subscribe(
          (res: HttpResponse<IPhone[]>) => this.paginatePhones(res.body, res.headers, firstLoad),
          (res: HttpErrorResponse) => this.onError(res.message)
        );
    });
  }
  protected onError(errorMessage: string) {
  }


  sort() {
    const result = [this.predicate + ',' + (this.reverse)];
    return result;
  }


}
